import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import styles from "../../table-actions-menu.module.scss";
import type { TableActionsMenuTriggerViewProps } from "./types-trigger";

/** Gatilho ⋮: botão outlined secondary de 40×35 (Figma 4988:57437); a tela troca `severity`/`outlined` pelas props do Prime. */
export function TableActionsMenuTriggerView({
  rest,
  id,
  testId,
  icon,
  className,
  ariaLabel,
  expanded,
  controls,
  onClick,
  triggerRef,
}: TableActionsMenuTriggerViewProps) {
  return (
    <Button
      type="button"
      outlined
      severity="secondary"
      data-testid={testId}
      {...rest}
      ref={undefined}
      id={id}
      icon={icon}
      className={classNames(styles.trigger, className)}
      aria-label={ariaLabel}
      aria-haspopup="menu"
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={onClick}
      pt={{ root: { ref: triggerRef } }}
    />
  );
}
